import {RestResource} from '../rest'
import {NOTICE_SERVER} from '../server'
import {athubAxios} from "@/util";
import notice from "@/api/notice/notice";

const noticePerson = new RestResource({server: NOTICE_SERVER, resource: 'noticePerson'});

noticePerson.batchUpdate = (noticePersonPage) => {
    let url = `${NOTICE_SERVER}/noticePerson/batchUpdate`;
    return new Promise((resolve, reject) => {
        athubAxios.put(url, noticePersonPage).then(responseBody => {
            if (responseBody.status == 200) {
                resolve(responseBody);
            }
        }).catch(error => {
            reject(error);
        });
    });
};

export default noticePerson;